import React from "react";
import Typography  from "@mui/material/Typography";
import  Button  from "@mui/material/Button";
import Container   from "@mui/material/Container";

import TextField from '@mui/material/TextField';



function Contact() {
  return <Container sx={{textAlign:'center'}}>
            <Typography
              color="primary.light"
              variant="h3"
              component="h3">
              Need help? feel free to contact us
            </Typography> 
            <form>
						<label> Name</label><br></br>
						<TextField id="standard-basic" label="Standard" variant="standard" />
            <br></br><br></br>
						<label> Contact</label><br></br>
						<TextField id="standard-basic" label="Standard" variant="standard" />
            <br></br><br></br>
						<label>Comments</label><br></br>
						<TextField id="standard-basic" label="Standard" variant="standard" />
            <br></br><br></br>
					  <Button type="submit">Submit form</Button >
            </form>
     

              <Typography
              color="primary"
              variant="p"
              component="p">
            
                11 The Parade<br></br>
                Neath<br></br>
                West Glamorgan<br></br>
                SA11 1RB<br></br>
                Phone: 07700 900000

                </Typography>    
  </Container >;
}

export default Contact;
